import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'

import { hasValidToken } from '@/features/auth/session'
import { SignUp } from '@/features/auth/sign-up'

export const Route = createFileRoute('/sign-up')({
  beforeLoad: () => {
    if (hasValidToken()) throw redirect({ to: '/', replace: true })
  },
  component: SignUpPage,
})

function SignUpPage() {
  const navigate = useNavigate()
  return <SignUp onSuccess={() => void navigate({ to: '/', replace: true })} />
}
